import * as React from 'react'
import styled from 'styled-components'
import ContainerProps from '../Resources'
import { media } from '../../../utils'

interface RowProps extends ContainerProps {
  renderImages: () => any
  whiteBgForImages?: boolean
  isHighlighted?: boolean
}

export const MultiImageConfigurator = (props: RowProps) => {
  const { whiteBgForImages, isHighlighted, renderImages, children } = props
  return (
    <ProductRowContainer highlight={isHighlighted}>
      <Images whiteBg={whiteBgForImages}>{renderImages()}</Images>
      <Content>{children}</Content>
    </ProductRowContainer>
  )
}

interface ImageProps {
  selected?: boolean
  siblings?: number
  img: any
}

export const ProductRowImage = (props: ImageProps) => {
  return <Image {...props} />
}

const ProductRowContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  height: auto;
  background-color: #d5e4e6;
  border: ${(props) => (props.highlight ? '2px solid #677D7F' : 'none')};
`

const Images = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-content: center;
  align-items: center;
  width: 40%;
  padding: 15px;
  background: ${(props) => (props.whiteBg ? 'white' : '#A7C9CD')};

  ${media.tablet`
    width: 100%;
    min-height: 180px;
  `}
`

export const Image = styled.div`
  width: ${(props) => (props.selected && props.siblings ? '50%' : '100%')};
  height: ${(props) => (props.selected && props.siblings ? '50%' : '100%')};
  max-width: 240px;
  max-height: 150px;
  background-repeat: no-repeat;
  background-size: ${(props) => (props.selected ? 'contain' : 'auto 35%')};
  background-position: center;
  background-image: url('${(props) => props.img}');

  ${media.tablet`
    width: 25%;
    height: 100%;
  `}
  ${media.largePhone`
    width: ${(props) => (props.selected && props.siblings ? '50%' : '100%')};
    height: ${(props) => (props.selected && props.siblings ? '50%' : '100%')};
  `}
`

const Content = styled.div`
  width: 60%;
  padding: 15px;

  ${media.tablet`
    min-height: 50%;
    width: 100%;
  `}
`



// WEBPACK FOOTER //
// ./src/components/containers/configurator/MultiImageConfigurator.tsx